// extracted by css-extract-rspack-plugin
export default {"message":"message-DSBZ52"};